import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSessionControl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.57941 1.00122H4.99972C3.93893 1.00122 2.92159 1.42268 2.17149 2.17277C1.42139 2.92287 1 3.94015 1 5.00094V15.0003C1 16.061 1.42139 17.0783 2.17149 17.8284C2.92159 18.5785 3.93893 19 4.99972 19H16.9989C18.0597 19 19.0771 18.5785 19.8271 17.8284C20.5772 17.0783 20.9986 16.061 20.9986 15.0003V10.9305",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.57941 7.00073H1",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 15.95H9.99959",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9685 9.06194C19.1947 9.06194 20.9994 7.25723 20.9994 5.03097C20.9994 2.80473 19.1947 1 16.9685 1C14.7422 1 12.9375 2.80473 12.9375 5.03097C12.9375 7.25723 14.7422 9.06194 16.9685 9.06194Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9668 2.34375V5.03106",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.8729 6.93712L16.9668 5.03101",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconSessionControl;
